import React from "react";
import Header from "../../components/ui/Header";
import ContactHero from "./components/ContactHero";
import ContactMethods from "./components/ContactMethods";
import ContactForms from "./components/ContactForms";

const ContactPage = () => {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="pt-16">
        <ContactHero />
        <ContactMethods />
        {/* <ContactForms /> */}
      </main>
      {/* Footer */}

      <footer
        className="text-black py-12 bg-blue-200"
        // style={{ backgroundColor: "#ffff00" }}
      >
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="grid md:grid-cols-4 gap-8">
            <div>
              <div className="flex items-center space-x-3 mb-6">
                <div className="w-10 h-10 bg-primary rounded-lg flex items-center justify-center">
                  <span className="text-black font-bold text-lg">K</span>
                </div>
                <div>
                  <h3 className="text-xl font-bold">KTTI</h3>
                  <p className="text-lg text-black/80"></p>
                </div>
              </div>
              <p className="text-black/80 text-lg">
                Transforming technical education through innovation, practical
                learning, and industry partnerships.
              </p>
            </div>

            <div>
              <h4 className="font-semibold mb-4">Quick Links</h4>
              <ul className="space-y-2 text-lg text-black/80">
                <li>
                  <a
                    href="/homepage"
                    className="hover:text-blue-700 transition-colors"
                  >
                    Home
                  </a>
                </li>
                <li>
                  <a
                    href="/about"
                    className="hover:text-blue-700 transition-colors"
                  >
                    About
                  </a>
                </li>
                <li>
                  <a
                    href="/departments"
                    className="hover:text-blue-700 transition-colors"
                  >
                    Departments
                  </a>
                </li>
                <li>
                  <a
                    href="/courses"
                    className="hover:text-blue-700 transition-colors"
                  >
                    Courses
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-semibold mb-4">Support</h4>
              <ul className="space-y-2 text-lg text-black/80">
                <li>
                  <a
                    href="/contact"
                    className="hover:text-blue-700 transition-colors"
                  >
                    Contact Us
                  </a>
                </li>
                <li>
                  <a
                    href="/resources"
                    className="hover:text-blue-700  transition-colors"
                  >
                    Resources
                  </a>
                </li>
                <li>
                  <a
                    href="https://karumottiportal.ac.ke"
                    target="_blank"
                    className="hover:text-blue-700 transition-colors"
                  >
                    Student Portal
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-semibold mb-4">Contact Info</h4>
              <div className="space-y-2 text-lg text-black/80">
                <p>+254 705636443</p>
                <p>info@karumotti.ac.ke</p>
                <p>3Km Off Kwa Amos Junction, Meru-Maua Road</p>
              </div>
            </div>
          </div>

          <div className="border-t border-black/20 mt-8 pt-8 text-center">
            <p className="text-black/80 text-m">
              © {new Date()?.getFullYear()} KTTI. All rights reserved.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default ContactPage;
